<template>
  <div>
    <p class="mt-md-2 mb-4">Password must contain at least:</p>
    <ul class="list-unstyled ml-2 ml-md-4 mb-0">
      <li>
        <password-requirement :satisfied="hasMinimumLength" text="12 characters"></password-requirement>
      </li>
      <li>
        <password-requirement
          :satisfied="hasLowerCaseLetter"
          text="1 lower case character (a-z)"
        ></password-requirement>
      </li>
      <li>
        <password-requirement
          :satisfied="hasUpperCaseLetter"
          text="1 upper case character (A-Z)"
        ></password-requirement>
      </li>
      <li>
        <password-requirement :satisfied="hasNumber" text="1 number (0-9)"></password-requirement>
      </li>
      <li>
        <password-requirement
          :satisfied="hasSpecialCharacter"
          text="1 special character (!@#$%^&amp;*)"
        ></password-requirement>
      </li>
    </ul>
  </div>
</template>

<script>
import PasswordRequirement from './PasswordRequirement';

export default {
  name: 'password-requirements',
  components: {PasswordRequirement},
  props: {
    password: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasMinimumLength() {
      return String(this.password).length >= 12;
    },
    hasLowerCaseLetter() {
      return /[a-z]/.test(this.password);
    },
    hasUpperCaseLetter() {
      return /[A-Z]/.test(this.password);
    },
    hasNumber() {
      return /[0-9]/.test(this.password);
    },
    hasSpecialCharacter() {
      return /[\!\@\#\$\%\^\&\*]/.test(this.password);
    },
    valid() {
      return (
        this.hasMinimumLength &&
        this.hasLowerCaseLetter &&
        this.hasUpperCaseLetter &&
        this.hasNumber &&
        this.hasSpecialCharacter
      );
    },
  },
  watch: {
    valid() {
      this.$emit('validity-change', this.valid);
    },
  },
};
</script>

<style lang="scss" scoped>
div {
    font-size: 16px;
}
</style>
